import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import {
  Table,
  TableBody,
  Typography,
  TablePagination,
  CircularProgress,
} from '@material-ui/core';

import TableHead from './TableHead';

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const styles = {
  tableWrapper: {
    overflowX: 'scroll',
  },
};

class EnhancedTable extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      order: 'asc',
      orderBy: props.orderBy,
      rowsPerPage: 20,
    };
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleChangePage = (event, page) => {
    this.props.history.replace(`?page=${page + 1}`);
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  renderRows(item, index) {
    const { renderRows } = this.props;
    return renderRows({ item, index });
  }

  renderPaginatedCells() {
    const { data } = this.props;
    const { order, orderBy } = this.state;

    return stableSort(data, getSorting(order, orderBy))
      .map((item, index) => (this.renderRows(item, index)));
  }

  renderCells() {
    const { data } = this.props;
    const { order, orderBy } = this.state;

    return stableSort(data, getSorting(order, orderBy))
      .map((item, index) => (this.renderRows(item, index)));
  }

  render() {
    const {
      data,
      page,
      rows,
      total,
      classes,
      paginated,
      isFetching,
      rowsPerPageOptions,
    } = this.props;
    const { order, orderBy, rowsPerPage } = this.state;

    return (
      <div>
        <div className={classes.tableWrapper}>
          <Table aria-labelledby="tableTitle">
            <TableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleRequestSort}
              rows={rows}
            />
            { !isFetching && !isEmpty(data) &&
              <TableBody>
                { paginated ? this.renderPaginatedCells() : this.renderCells() }
              </TableBody> }
          </Table>
          { !isFetching && isEmpty(data) &&
            <div className="flex justify-center m-40">
              <Typography variant="body1" color="textSecondary"> No hay registros para mostrar. </Typography>
            </div> }
          { isFetching && <div className="flex justify-center m-40">
            <CircularProgress size={40} />
          </div> }
        </div>
        { (paginated && !isFetching) && <TablePagination
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          rowsPerPageOptions={rowsPerPageOptions}
          backIconButtonProps={{
            'aria-label': 'Página Anterior',
          }}
          nextIconButtonProps={{
            'aria-label': 'Página Siguiente',
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />}
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  rows: PropTypes.array.isRequired,
  renderRows: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  orderBy: PropTypes.string,
  paginated: PropTypes.bool,
  isFetching: PropTypes.bool,
  total: PropTypes.number,
  history: PropTypes.object,
  page: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
};

EnhancedTable.defaultProps = {
  paginated: false,
  isFetching: false,
  history: {},
  orderBy: '',
  total: 0,
  pages: 0,
  page: 0,
  rowsPerPageOptions: [],
};

export default withStyles(styles)(EnhancedTable);



// WEBPACK FOOTER //
// ./src/components/Table.js